module.exports = __webpack_public_path__ + "static/media/DSCF9034.17ab3f84.JPG";